import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { mdiBankOutline, mdiBankPlus, mdiPencil } from '@mdi/js';
import { useRouteMatch, Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import Icon from '@mdi/react';
import { loadPaymentSystems } from '../../../redux/modules/payment_systems';
import StyledTable from '../../../components/StyledTable/StyledTable';
import FullPageLoader from '../../../components/FullPageLoader/FullPageLoader';
import PageTitle from '../../../components/PageTitle/PageTitle';

const PaymentSystemsList = () => {
    const dispatch                = useDispatch();
    const { path }                = useRouteMatch();
    const { t }                   = useTranslation();
    const { isLoading, payment_systems } = useSelector(state => state.payment_systems);

    useEffect(() => {
        dispatch(loadPaymentSystems());
    }, [dispatch]);

    if (!payment_systems || isLoading) {
        return <FullPageLoader />
    }

    const actionFormatter = (id, payment_system) =>
        <Button tag={ Link } to={ `${path}/edit/${id}` } color="success"><Icon path={ mdiPencil } size={ 1 } color="white" /></Button>;

    const columns = [{
        dataField: 'name',
        text: t('payment_systems.name'),
        sort: true
    }, {
        dataField: 'id',
        text: t('common.actions'),
        sort: false,
        formatter: actionFormatter,
        csvExport: false
    }];

    const defaultSorted = [{
        dataField: 'fullname',
        order: 'desc'
    }];

    const actions = <Link to={`${path}/new`}>
        <Button color="info">
            <Icon path={ mdiBankPlus } size={ 1 } color="white" /> { t('payment_systems.add') }
        </Button>
    </Link>;

    return (
        <div className="PaymentSystemsList">
            <PageTitle
                title={ t('payment_systems.list_title') }
                icon={ <Icon path={ mdiBankOutline } color="white" /> }
                actions={ actions }
            />
            <StyledTable
                bootstrap4
                keyField="id"
                data={ payment_systems }
                columns={ columns }
                defaultSorted={ defaultSorted }
                sizePerPage= { 5 }
            />
        </div>
    );
}

export default PaymentSystemsList;
